import React, { useCallback, useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Loading from "../common/Loading";
import MusicShell from "../fanHome/MusicShell";
import { ACCENT } from "../artistStudio/shared";
import { INK, MUTED, PANEL_LINE } from "../fanHome/libraryParts";
import { preferencesApi, apiErrorMessage } from "./fanMembershipApi";

// Payment methods (My Plan): the cards saved for automatic licence renewal. Read only - the card number is never shown or kept here.
// To stop a card being used, turn automatic renewal off on the licence in My Library.
const BRANDS = { visa: "Visa", mastercard: "Mastercard", amex: "American Express", discover: "Discover", diners: "Diners Club", jcb: "JCB", unionpay: "UnionPay" };
export const brandName = (brand) => BRANDS[String(brand || "").toLowerCase()] || "Card";
export const expiry = (month, year) => `${String(month).padStart(2, "0")}/${String(year).slice(-2)}`;

export default function PaymentMethods() {
  const [state, setState] = useState({ loading: true, cards: [], error: "" });
  const load = useCallback(async () => {
    setState({ loading: true, cards: [], error: "" });
    try {
      const data = await preferencesApi.cards();
      setState({ loading: false, cards: data?.cards || [], error: "" });
    } catch (e) {
      setState({ loading: false, cards: [], error: apiErrorMessage(e, "Your saved cards could not be loaded. Please try again.") });
    }
  }, []);
  useEffect(() => { load(); }, [load]);

  const { loading, cards, error } = state;
  return (
    <MusicShell>
      <Link to="/fan/plan" className="text-sm font-semibold hover:underline" style={{ color: ACCENT }}>← My Plan</Link>
      <h1 className="mt-2 text-[28px] font-bold leading-tight" style={{ color: INK }}>Payment methods</h1>
      {loading && <div className="flex justify-center py-20" role="status" aria-label="Loading cards"><Loading /></div>}
      {!loading && error && (
        <div className="py-12 max-w-md">
          <p className="mb-4 text-gray-700" role="alert">{error}</p>
          <button type="button" onClick={load} className="rounded-full px-6 py-2.5 font-semibold text-white" style={{ backgroundColor: ACCENT }}>Try again</button>
        </div>
      )}
      {!loading && !error && (
        <div className="mt-6 max-w-3xl">
          {cards.length === 0 ? (
            <p className="text-[15px]" style={{ color: MUTED }}>
              No saved cards. A card is saved only when you choose automatic renewal while buying a licence.
            </p>
          ) : (
            <ul>
              {cards.map((c) => (
                <li key={c.id} className="flex items-center justify-between gap-4 border-b py-4" style={{ borderColor: PANEL_LINE }}>
                  <div>
                    <p className="text-[15px] font-semibold" style={{ color: INK }}>{brandName(c.brand)} ending {c.last4}</p>
                    <p className="mt-0.5 text-sm" style={{ color: MUTED }}>Expires {expiry(c.exp_month, c.exp_year)}</p>
                  </div>
                  <p className="text-sm" style={{ color: MUTED }}>
                    {c.renewing_licences > 0 ? `Renews ${c.renewing_licences} ${c.renewing_licences === 1 ? "licence" : "licences"}` : "Not used for renewal"}
                  </p>
                </li>
              ))}
            </ul>
          )}
          <p className="mt-6 text-sm" style={{ color: MUTED }}>
            To stop a card being used, turn off automatic renewal on the licence in <Link to="/fan/library" className="font-semibold hover:underline" style={{ color: ACCENT }}>My Library</Link>.
          </p>
        </div>
      )}
    </MusicShell>
  );
}
